import { Controller, useFormContext } from 'react-hook-form';
import { Grid, Radio, FormControlLabel, FormControl, FormLabel, RadioGroup, FormHelperText } from '@mui/material';
import { Constants } from '@shared';

export const StepAnticipatedMonthlySpend = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Grid container>
      <Grid item xs={12}>
        <FormControl fullWidth margin='normal' error={!!errors.anticipatedMonthlySpend}>
          <FormLabel component='label'>Anticipated Monthly Spend *</FormLabel>
          <RadioGroup row>
            {Object.keys(Constants.ANTICIPATED_MONTHLY_SPENDS).map((key, idx) => (
              <FormControlLabel
                key={idx}
                label={Constants.ANTICIPATED_MONTHLY_SPENDS[key as keyof typeof Constants.ANTICIPATED_MONTHLY_SPENDS]}
                labelPlacement='end'
                control={
                  <Controller
                    name='anticipatedMonthlySpend'
                    control={control}
                    rules={{ required: 'Anticipated Monthly Spend is required' }}
                    render={({ field }) => <Radio color='primary' {...field} value={key} checked={key === field.value} />}
                  />
                }
              />
            ))}
          </RadioGroup>
          {errors?.anticipatedMonthlySpend?.message && <FormHelperText error>{errors.anticipatedMonthlySpend.message as string}</FormHelperText>}
        </FormControl>
      </Grid>
    </Grid>
  );
};
